import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Link, useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import SubmitButton from 'components/Widgets/SubmitButton';

import routes from 'app/routes';
import StepTab from 'components/new_ui/Tabs/StepTab';
import { useContext } from 'components/Members/Programs/Views/Show/Context';
import { useContext as useUsersContext } from 'components/Users/Context';

import useCareerPulseQuestions from 'components/Common/CareerPulseQuestions/Hooks/useCareerPulseQuestions';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';

import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import HorizontalSelectRadioField from 'components/new_ui/Form/HorizontalSelectRadioField';
import Actions from './Actions';

export default function Index({ showSteps }) {
  const { state } = useContext();
  const navigate = useNavigate();

  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUser } = useUsersContext();

  const careerPulseQuestions = useCareerPulseQuestions();

  const [questions, setQuestion] = useState(null);
  const [initFormValues, setInitFormValues] = useState(null);
  const [formSchema, setFormSchema] = useState({});

  const member = stateUser.user?.attributes?.specific;

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'New Program',
    },
  ];

  const onSubmitHundler = (values, { setSubmitting }) => {
    Actions.updateGoals(
      member.id,
      values,
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        navigate(routes.members.programs.new_ai.prepareProgram);
      },
    );
  };

  useEffect(() => {
    if (careerPulseQuestions) {
      const formQuestions = careerPulseQuestions.filter((item) => item.attributes.name.includes('CUSTOM_AI'));
      setQuestion(formQuestions);
      const formValues = {};
      const schema = {};
      formQuestions.forEach((item) => {
        formValues[item.attributes.name] = stateUser.user.attributes.specific.ai_goals
          .find((data) => data.code === item.attributes.name)?.answer_weight;

        schema[item.attributes.name] = Yup.number().nullable().required('Please, select Answer');
      });
      setInitFormValues(formValues);
      setFormSchema(schema);
    }
  }, [careerPulseQuestions]);

  useEffect(() => {
    if (state.program) {
      const nextUrl = routes.members.programs.new_ai.orderTopics(state.program.id);
      navigate(nextUrl, { replace: true });
    }
  }, [state.program]);

  if (questions === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <>
      {showSteps && (
      <StepTab
        total={3}
        current={1}
      />
      )}

      <div className="content">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1>Pick A Goal</h1>
        </section>

        <Formik
          initialValues={initFormValues}
          validationSchema={Yup.object().shape(formSchema)}
          onSubmit={onSubmitHundler}
        >
          {({ isSubmitting }) => (
            <FormikForm className="needs-validation" noValidate="">

              <section className="form-with-counter ">

                {questions.map((question) => (
                  <Row>
                    <Col>
                      <HorizontalSelectRadioField
                        name={question.attributes.name}
                        label={question.attributes.title}
                        containerClassName="select-counter-form"
                        collection={question.attributes.answers.map((el) => ({
                          label: (
                            <div>
                              <div>{el.title.split('—').slice(0, 2).join('—')}</div>
                              <span className="small">{el.title.split('—')[2]}</span>
                            </div>
                          ),
                          value: el.weightage,
                        }))}
                      />

                    </Col>
                  </Row>
                ))}
              </section>

              <footer className="d-lg-flex flex-row-reverse">
                <div className="d-md-flex flex-lg-row-reverse mb-3 mb-lg-0 ms-lg-3">
                  <div className="flex-grow-1 d-block d-md-inline-block ms-0 ms-md-3">

                    <SubmitButton loading={isSubmitting}>
                      Next
                    </SubmitButton>

                  </div>
                </div>

                <div className="flex-grow-1 d-md-flex">
                  <Link
                    to={routes.members.programs.chooseType}
                    className="btn btn-outline-primary d-block d-md-inline-block ms-0"
                  >
                    Previous
                  </Link>
                </div>
              </footer>

            </FormikForm>
          )}
        </Formik>

      </div>

    </>
  );
}

Index.propTypes = {
  showSteps: PropTypes.bool,
};

Index.defaultProps = {
  showSteps: true,
};
